export default __webpack_public_path__ + "media/images/lp/conversion-main-sp-f03dc285307de5ba73efcc82394ae2c9.png";